module.exports = __webpack_public_path__ + "static/media/pdf-icon.acc279b4.png";